import { jsx } from 'react/jsx-runtime';
import BadgeAlarmIcon from '../../Icons/BadgeAlarmIcon.js';
import BadgeSuccessIcon from '../../Icons/BadgeSuccessIcon.js';
import BadgeWarningIcon from '../../Icons/BadgeWarningIcon.js';
import Spinner from '../../Spinner/Spinner.js';
import { EmphasisLM } from '../../types.js';
import AlertIcon from './FormFieldFrame/AlertIcon.js';

var FieldConfirmMode;
(function (FieldConfirmMode) {
    FieldConfirmMode[FieldConfirmMode["NONE"] = 0] = "NONE";
    // eslint-disable-next-line no-bitwise
    FieldConfirmMode[FieldConfirmMode["ON_BLUR"] = 1] = "ON_BLUR";
    // eslint-disable-next-line no-bitwise
    FieldConfirmMode[FieldConfirmMode["ON_EDITING"] = 2] = "ON_EDITING";
    // eslint-disable-next-line no-bitwise
    FieldConfirmMode[FieldConfirmMode["ON_EDITING_BLUR"] = 3] = "ON_EDITING_BLUR";
})(FieldConfirmMode || (FieldConfirmMode = {}));
var FieldFlowMode;
(function (FieldFlowMode) {
    FieldFlowMode["NONE"] = "NONE";
    FieldFlowMode["GO_TO_NEXT_ON_ENTER"] = "NEXT_ON_ENTER";
})(FieldFlowMode || (FieldFlowMode = {}));
function isConfirmOnEditing(mode) {
    // eslint-disable-next-line no-bitwise
    return (mode & FieldConfirmMode.ON_EDITING) === FieldConfirmMode.ON_EDITING;
}
function isConfirmOnBlur(mode) {
    // eslint-disable-next-line no-bitwise
    return (mode & FieldConfirmMode.ON_BLUR) === FieldConfirmMode.ON_BLUR;
}
var InputStatesEnum;
(function (InputStatesEnum) {
    InputStatesEnum["alarm"] = "alarm";
    InputStatesEnum["success"] = "success";
    InputStatesEnum["warning"] = "warning";
    InputStatesEnum["loading"] = "loading";
})(InputStatesEnum || (InputStatesEnum = {}));
var SelectStatesEnum;
(function (SelectStatesEnum) {
    SelectStatesEnum["alarm"] = "alarm";
    SelectStatesEnum["success"] = "success";
    SelectStatesEnum["warning"] = "warning";
    SelectStatesEnum["loading"] = "loading";
    SelectStatesEnum["loadingPage"] = "loading-page";
})(SelectStatesEnum || (SelectStatesEnum = {}));
const InputStates = InputStatesEnum;
function getInputState(state) {
    if (state === undefined)
        return undefined;
    const enumArray = Object.values(InputStates);
    const index = enumArray.map((v) => v.valueOf()).indexOf(state.valueOf());
    if (index >= 0)
        return enumArray[index];
    return InputStatesEnum.loading;
}
const InputStatesList = [InputStates.alarm, InputStates.success, InputStates.warning, InputStates.loading];
function createBadgeStatus(state, emphasis) {
    if (state === InputStatesEnum.loading) {
        return jsx(Spinner, { small: true });
    }
    if (emphasis === EmphasisLM.LOW && !!state) {
        return jsx(AlertIcon, {});
    }
    switch (state) {
        case InputStatesEnum.alarm: return jsx(BadgeAlarmIcon, {});
        case InputStatesEnum.warning: return jsx(BadgeWarningIcon, {});
        case InputStatesEnum.success: return jsx(BadgeSuccessIcon, {});
        default:
            return null;
    }
}
const SelectStates = SelectStatesEnum;
const SelectStatesList = Object.values(SelectStates);
var FileToUploadErrorType;
(function (FileToUploadErrorType) {
    FileToUploadErrorType[FileToUploadErrorType["ACCEPT_ERROR"] = 0] = "ACCEPT_ERROR";
})(FileToUploadErrorType || (FileToUploadErrorType = {}));

export { FieldConfirmMode, FieldFlowMode, FileToUploadErrorType, EmphasisLM as InputEmphasis, InputStates, InputStatesEnum, InputStatesList, SelectStates, SelectStatesEnum, SelectStatesList, createBadgeStatus, getInputState, isConfirmOnBlur, isConfirmOnEditing };
